const stepstoneMappings = {
  ACCOUNTS: {
    "Sander Brussels": "brussels",
    "Sander Antwerp": "antwerp",
  },

  GEOGRAPHY_IDS: {
    "antwerp": 198,
    "brussels": 207,
    "east_flanders": 199,
    "flemish_brabant": 200,
    "hainaut": 201,
    "liege": 202,
    "limburg": 203,
    "luxembourg": 208,
    "namur": 204,
    "walloon_brabant": 205,
    "west_flanders": 206
  },

  // WORKFIELD_IDS: {
  //   "IT and Telecommunications": 1000000,
  //   "Engineering & Technical Jobs": 10000000,
  //   "Sales & Purchasing": 2000000,
  //   "Finance Administration & Auditing": 4000000,
  //   "Banking, Finance Services & Insurance": 3000000,
  //   "Administrative Support & Secretarial": 7000000,
  //   "Human Resources": 5000000,
  //   "Marketing & Advertising": 6000000,
  //   "Media & Information": 19000000,
  //   "General Management": 11000000,
  //   "Transport & Logistics": 8000000,
  //   "Manufacturing, Building and Manual Work": 9000000,
  //   "R&D, Science & Scientific Research": 13000000,
  //   "Health, Medicine, Social & Fitness": 14000000,
  //   "Land, Sea, Environment & Veterinary": 16000000,
  //   "Accommodation, Catering & Tourism": 15000000,
  //   "Law": 12000000,
  //   "Design & Architecture": 21000000,
  //   "Education & Training": 22000000,
  //   "Culture & Fine Arts": 20000000,
  //   "Police, Security and Protective": 18000000,
  //   "Public Services": 17000000,
  //   "Application Analysis": 1002000,
  //   "Application Development & Programming": 1003000,
  //   "Applications Administration": 1004000,
  //   "Hardware Design & Engineering": 1001000,
  //   "Helpdesk & Technical Support": 1007000,
  //   "IT-Architecture": 1018000,
  //   "IT-Consulting": 1012000,
  //   "IT-Management": 1008000,
  //   "IT-Project Management": 1009000,
  //   "IT-Quality Assurance & Inspection": 1011000,
  //   "IT-Training": 1015000,
  //   "Product Manager/ Functional or Business Analyst": 1019000,
  //   "System Administration / Management": 1016000,
  //   "Technical Editorial": 1017000,
  //   "Webdesign & Webmaster": 1010000,
  //   "Others: IT & Telecommunication": 1013000,
  //   "Data Processing": 1005002,
  //   "Data Warehousing": 1005003,
  //   "Database Administration": 1005001,
  //   "Network Administration & Security": 1006002,
  //   "Network Operations & Maintenance": 1006001,
  //   "Telecommunication & Mobile Systems": 1006003,
  //   "Informatics": 1014000,
  //   "Call Centre & Telesales": 2001000,
  //   "Customer Service": 2004000,
  //   "Sales Management": 2002000,
  //   "Sales Support/Administration": 2006000,
  //   "Others: Sales & Purchasing": 2008000,
  //   "(Key) Account Management": 2003001,
  //   "Field Service": 2003002,
  //   "Representative": 2003003,
  //   "Cashier/Shop Assistant": 2005002,
  //   "Retail Management": 2005001,
  //   "Buyer": 2007002,
  //   "Purchasing Manager": 2007001,
  //   "Analysis, Compliance & Consultancy": 3001000,
  //   "Banking": 3002000,
  //   "Insurance": 3004000,
  //   "Stock Exchange": 3003002,
  //   "Trading & Brokerage": 3003001,
  //   "Project Management": 3005003,
  //   "Real Estate & Facility Management": 3005002,
  //   "Others: Bank & Finance Services": 3005001,
  //   "Accounting": 4002000,
  //   "Auditing": 4001000,
  //   "Cash Management & Treasury": 4003000,
  //   "Controller": 4004000,
  //   "Financial Consultants": 4007000,
  //   "Financial Management": 4005000,
  //   "Tax Advisor": 4006000,
  //   "Others: Finance Administration & Auditing": 4008000,
  //   "Compensation & Benefits": 5001000,
  //   "HR Administration": 5003000,
  //   "HR Manager": 5004000,
  //   "Payroll": 5002000,
  //   "Recruitment & Selection": 5006000,
  //   "Training & Development": 5005000,
  //   "HR Consulting": 5007002,
  //   "Staffing Consultant": 5007003,
  //   "Others: HR related": 5007001,
  //   "Advertising & Communication": 6007000,
  //   "Database & Direct Marketing": 6003000,
  //   "Event Marketing": 6004000,
  //   "Market Research & Analysis": 6005000,
  //   "Marketing Manager": 6001000,
  //   "Marketing Assistant": 6012000,
  //   "Media planning & Purchasing": 6008000,
  //   "Product Management": 6002000,
  //   "Public & Investor Relations": 6006000,
  //   "Sales Support": 6009000,
  //   "Trade Marketing": 6010000,
  //   "Others: Marketing & Advertising": 6011000,
  //   "Archives & Documentation": 7005000,
  //   "Assistant": 7004000,
  //   "Clerk": 7006000,
  //   "Foreign Language & Translation": 7007000,
  //   "Office Management": 7002000,
  //   "Reception & Operator": 7003000,
  //   "Secretarial": 7001000,
  //   "Others: Administrative Support & Secretarial": 7008000,
  //   "Postman & Couriers": 8004000,
  //   "Supply Chain Management": 8006000,
  //   "Transport & Logistics Manager": 8002000,
  //   "Warehouseman": 8001000,
  //   "Others: Transport & Logistics": 8005000,
  //   "Air Transport": 8003001,
  //   "Ports, Sea Transports & Inland Waterways": 8003004,
  //   "Rail Transport": 8003003,
  //   "Road Transport": 8003002,
  //   "Construction Worker": 9005000,
  //   "Electrician": 9004000,
  //   "Food Manufacturing": 9006000,
  //   "Industrial Manufacturing & Production": 9008000,
  //   "Painter & Varnisher": 9001000,
  //   "Personal Care": 9007000,
  //   "Quality Assurance / Environmental & Prevention Advice": 9011000,
  //   "Carpenter": 9002002,
  //   "Joiner": 9002001,
  //   "Mechanic": 9003003,
  //   "Plumber": 9003001,
  //   "Tool-Maker": 9003004,
  //   "Welder": 9003002,
  //   "Cost Assessor": 9009003,
  //   "Foreman": 9009002,
  //   "Others: Manufacturing, Building & Handcraft": 9009001,
  //   "Chemical Engineering": 10007000,
  //   "CAD Construction / Visualising": 10011000,
  //   "Construction Engineering/Civil Engineering": 10006000,
  //   "Electrical Engineering": 10002000,
  //   "Electronic Engineer": 10003000,
  //   "Engineering Consultants": 10008000,
  //   "Materials Science": 10005000,
  //   "Process Engineering": 10001000,
  //   "Technical Jobs": 10009000,
  //   "Electromechanical Engineer": 10004002,
  //   "Mechanical Engineering": 10004001,
  //   "Bio Engineering": 10010002,
  //   "Maintenance & Production Engineer": 10010004,
  //   "Production & Operations Management": 10010003,
  //   "Others: Engineering & Technical Jobs": 10010001,
  //   "Business Consulting": 11005000,
  //   "Business Development": 11003000,
  //   "Directors and Chief Executives": 11001000,
  //   "Operations Management": 11004000,
  //   "Partner": 11006002,
  //   "Others: General Management": 11006001,
  //   "Administration of Justice (Judges)": 12004000,
  //   "Attorneyship (Lawyers)": 12001000,
  //   "Court, Notary & Legal Assistant": 12003000,
  //   "Legal Department": 12002000,
  //   "Notary": 12005000,
  //   "Others: Law related": 12006000,
  //   "Mathematics, Statistics & Informatics": 13002000,
  //   "Others: R&D, Science & Scientific Research": 13004000,
  //   "Bio Technology": 13001002,
  //   "Chemistry, Physics & Biology": 13001001,
  //   "Laboratory Work": 13003003,
  //   "Quality Assurance": 13003002,
  //   "Research & Development": 13003001,
  //   "Medical Research & Laboratory Sciences": 14004000,
  //   "Medicine, Dentistry, Pharmacy": 14001000,
  //   "Nursing, Medical Support & Auxiliary Services": 14003000,
  //   "Opticians & Ophthalmologist": 14002000,
  //   "Social, Youth & Community Work": 14005000,
  //   "Sports & Fitness": 14006000,
  //   "Others: Health, Medicine, Social & Fitness": 14007000,
  //   "Hotel Management": 15001000,
  //   "Travel & Tourism": 15003000,
  //   "Cleaning Staff": 15002003,
  //   "Kitchen Staff": 15002002,
  //   "Waiters and related": 15002001,
  //   "Receptionist/Reception Manager": 15004001,
  //   "Others: Accommodation, Catering & Tourism": 15004002,
  //   "Agriculture, Fishing, Gardening": 16001000,
  //   "Veterinary Science, Animal Health & Welfare": 16002000,
  //   "Others: Land, Sea, Environment & Veterinary": 16004000,
  //   "Environmental & Nature Conservation": 16003001,
  //   "Waste Management": 16003002,
  //   "Ambassador and Diplomatic Representatives": 17001000,
  //   "Civil Servant Federal Affairs": 17003000,
  //   "Civil Servant Foreign Affairs": 17002000,
  //   "Customs Officials": 17006000,
  //   "Government Custom and Excise Officers": 17005000,
  //   "Local Government officials": 17004000,
  //   "Others: Civil Services": 17007000,
  //   "Armed Forces": 18003000,
  //   "Fire Department": 18002000,
  //   "Police, Prison & Related Work": 18001000,
  //   "Security/Security Guard": 18006000,
  //   "Others: Security & Protective Services": 18005000,
  //   "Film, TV, Radio & Multimedia": 19003000,
  //   "Journalism & Writing": 19001000,
  //   "Publishing": 19002000,
  //   "Others: Media & Information": 19004000,
  //   "Others: Culture & Fine Arts": 20003000,
  //   "History & Archeology": 20001002,
  //   "Library": 20001004,
  //   "Museum & Gallery": 20001001,
  //   "Theater & Playhouse, Music, Dance": 20001003,
  //   "Artists and Related": 20002002,
  //   "Photography": 20002001,
  //   "Others: Design & Architecture": 21003000,
  //   "Architecture": 21001001,
  //   "Landscaping & Landscaping Architecture": 21001002,
  //   "Fashion & Clothing Design": 21002003,
  //   "Illustration & Graphic Design": 21002001,
  //   "Industrial & Product Design": 21002002,
  //   "Interior Design & Decoration": 21002004,
  //   "High School": 22003000,
  //   "Kindergarten, Preschool": 22001000,
  //   "Primary School": 22002000,
  //   "Specialised Training": 22005000,
  //   "University & Academy": 22004000,
  //   "Others: Education & Training": 22006000
  // },

  SECTOR_IDS: {
    "Advertising, Communication & PR": 24000,
    "Agriculture, Fishing & Forestry": 1000,
    "Armed Forces": 27001,
    "Art, Culture, Entertainment & Sport": 30001,
    "Auditing/Accounting": 23003,
    "Automotive Sector": 10001,
    "Banking, Financial Services & Insurance": 19000,
    "Building & Construction": 14000,
    "Chemical & Petrochemical Industry": 7000,
    "Conservation & Environment": 31001,
    "Consulting": 23001,
    "Distribution, Transport & Logistics": 17000,
    "Education & Training": 28000,
    "Electricity, Gas & Water Supply": 13000,
    "Fast Moving Consumer Goods/ Durables": 11000,
    "Food & Beverages": 3000,
    "Hotels, Restaurants & Catering": 16000,
    "HR Services, Recruitment & Selection": 25000,
    "IT & Internet": 21000,
    "Legal": 23002,
    "Leisure & Tourism": 30002,
    "Manufacturing": 12000,
    "Media, Audiovisual & Publishing": 6002,
    "Medical Technology": 32000,
    "Medical, Health & Social Care": 29000,
    "Mining & Quarrying": 2000,
    "Other": 31002,
    "Other Business Activities & Services": 26000,
    "Pharmaceutical Sector": 8000,
    "Printing Industry": 6001,
    "Public Administration": 27002,
    "Public Services": 27003,
    "Real Estate": 20000,
    "Research & Development": 22000,
    "Space and Aerospace": 10002,
    "Steel Industry": 9000,
    "Telecommunication Services": 18000,
    "Textiles, Clothing & Leather, Fashion": 4000,
    "Wholesale, Retail Trade": 15000
  },

  CONTRACTTYPE_IDS: {
    "Contract duration unspecified": 901,
    "Contract duration specified": 902,
    "Temporary": 903,
    "Temporary with possibility of permanence": 914,
    "Franchise": 904,
    "Freelance": 906,
    "Apprenticeship": 907,
    "Internship": 909,
    "Student Job/ Seasonal Job": 910,
  },

  WORKTYPE_IDS: {
    "Full Time": 80001,
    "Part Time": 80002,
  },

  EXPERIENCE_IDS: {
    "No Experience/ First Jobs": 90001,
    "Experience required": 90002,
    "Executive Jobs": 90003,
  },

  SITUATION_IDS: {
    "Employee": 91000,
    "Unemployed": 91001,
    "Statutary": 91002,
    "Student": 91003,
    "Manual Worker": 91004,
    "Independent": 91005,
  },
};

export default stepstoneMappings;
